import React from 'react' 
import Bredcom from '../Bredcom/Main' 
import Header from '../headerone/Main' 


 
function UniversityStudentsGrievancesRedressalCommittee() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="University Students Grievances Redressal Committee" />
        <section className="project-detail">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="text-column col-lg-12 col-md-12 col-sm-12">                               
                                <div className="inner-column">
                                    <h2>University Students Grievances Redressal Committee</h2>
                                    <table className="table table-bordered mb-40">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Ramveer Singh</td>
                                                <td>Chairmain</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Dr. D.V Pathak</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Dr. Tarun Virmani</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Dr. Rahul Varshney</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Dr. Kuldeep Tanwar</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>Dr. Ruby Mittal</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>Ms. Manju Mala H Roy</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>Mr. Deepak (22SL4003)</td>
                                                <td>Student Representative (UG)</td>
                                            </tr>
                                            <tr>
                                                <td>9</td>
                                                <td>Ms Varsha (22MS5012)</td>
                                                <td>Student Representative (PG)</td>
                                            </tr>
                                            <tr>
                                                <td>10</td>
                                                <td>Dy. Registrar</td>
                                                <td>Member Secretary</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        
    </> 
  ) 
} 
 
export default UniversityStudentsGrievancesRedressalCommittee 